<template>
  <div class="content-center">
    <div class="banner">
      <div class="title">电商代运营服务</div>
      <div class="description">汇通数科代运营业务以电商托管运营为核心，以渠道运营、直播代运营、门店代运营，流量代运营及大数据研发等业务板块为辅助，为企业业务赋能。以技术为驱动力，以实力为上升力，为品牌/商家提供整体互联网商业解决方案和服务，开启新商业时代，实现品牌业务新增长、新发展、新突破。</div>
      <div
        class="btn"
        @click="openModal"
      >业务咨询</div>
    </div>
    <div class="basic">
      <div class="sk-block-title">
        <div class="title">基础代运营服务</div>
      </div>
      <div class="content">
        <img src="@/assets/images/industry/agentOperation_basic.png" alt="">
      </div>
    </div>
    <div class="increment">
      <div class="sk-block-title">
        <div class="title">增值代运营服务</div>
      </div>
      <div class="content">
        <img src="@/assets/images/industry/agentOperation_increment1.png" alt="">
        <img src="@/assets/images/industry/agentOperation_increment2.png" alt="">
        <img src="@/assets/images/industry/agentOperation_increment3.png" alt="">
      </div>
    </div>
    <div class="matching">
      <div class="title">增值配套服务</div>
      <div class="content">
        <img src="@/assets/images/industry/agentOperation_matching.png" alt="">
      </div>
    </div>
    <CarouselItem title="代运营服务" />
    <ConsultForm info-sources="代运营服务" />
    <TryModal v-if="visible" :visible="visible" info-sources="代运营服务" @cancel="modalClose" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ConsultForm from '@/components/ConsultForm'
import TryModal from '@/components/TryModal'
import CarouselItem from '@/components/CarouselItem'

export default {
  metaInfo: metaInfo.AgentOperation,
  components: {
    ConsultForm,
    TryModal,
    CarouselItem
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {

  },
  methods: {
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>

<style lang="less" scoped>
  .banner {
    padding: 73px 0 60px;
    background: url("~@/assets/images/industry/agentOperation_banner-bg.png") no-repeat center;
    .title {
      height: 66px;
      font-size: 48px;
      color: #FFFFFF;
      line-height: 55px;
    }
    .description {
      width: 1080px;
      height: 146px;
      font-size: 20px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 28px;
      margin: 20px auto 0;
    }
    .btn {
      width: 200px;
      height: 58px;
      line-height: 58px;
      background: #3986FF;
      border-radius: 6px;
      color: #fff;
      font-size: 22px;
      margin: 0 auto;
    }
  }
  .increment {
    background: #fafafa;
    padding-bottom: 50px;
    .content {
      width: 1220px;
      margin: 45px auto 0;
      display: flex;
      justify-content: space-between;
    }
  }
  .matching {
    background: url("~@/assets/images/industry/agentOperation_matching-bg.png") no-repeat;
    padding: 76px 0 51px;
    .title {
      font-size: 32px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 45px;
    }
    .content {
      margin-top: 57px;
    }
  }
</style>
